import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
  TextField,
} from "@material-ui/core";
import AWS from "aws-sdk";
import Swal from "sweetalert2";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { Auth } from "aws-amplify";
import { Link } from "react-router-dom/cjs/react-router-dom";

export default function Vendor({ title, link }) {
  const [file, setFile] = useState(null);
  const [trainload, setTrainload] = useState(false);
  const [compareLoad, setCompareLoad] = useState(false);
  const [deleteError, setdeleteError] = useState("");
  const [file1, setFile1] = useState(null);
  const [zipdone, setZipDone] = useState(false);
  const [pdfdone, setPdfDone] = useState(false);
  const [error, setError] = useState("");
  const [error1, setError1] = useState("");
  const [userquery, setUserQuery] = useState("");
  const [selectLanguageDisplay, setSelectLanguageDisplay] = useState("en");
  const [answerload, setAnswerload] = useState(false);
  const [trainError, setTrainError] = useState("");
  const [queryError, setQueryError] = useState("");
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };
  const handleFileChange1 = (event) => {
    setFile1(event.target.files[0]);
  };
  const [transcript, setTranScript] = useState("");
  const [displayText, setDisplayText] = useState("");

  useEffect(() => {
    if (transcript.length > 0) {
      let index = 0;
      const intevalId = setInterval(() => {
        setDisplayText((prev) => prev + transcript[index]);
        index++;
        if (index === transcript.length) {
          clearInterval(intevalId);
        }
      }, 25);
    }
  }, [transcript]);

  const deleteObjectsFromFolder = async () => {
    try {
      var username = localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      );
      const params = {
        Bucket: "python-libs-customchat",
        Prefix: username,
      };
      AWS.config.update({
        accessKeyId: "AKIA3AQTRT6P7J7N3JUJ",
        secretAccessKey: "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",
        region: "ap-south-1",
      });
      const s3 = new AWS.S3();
      const data = await s3.listObjectsV2(params).promise();

      if (data.Contents.length === 0) {
        console.log("No objects found in the folder.");
        return;
      }

      const objects = data.Contents.map(({ Key }) => {
        if (!Key.includes("/prompts/")) {
          return { Key };
        } else {
          return null;
        }
      });
      let array = objects.filter((element) => element !== null);
      await s3
        .deleteObjects({
          Bucket: "python-libs-customchat",
          Delete: { Objects: array },
        })
        .promise();

      console.log("Objects deleted successfully.");
      // setdeleteError("Trained data deleted successfully!");
    } catch (error) {
      console.error("Error deleting objects:", error);
      // setdeleteError("Error occured while deleting trained data!");
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    setAnswerload(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("language", selectLanguageDisplay);
    try {
      const response = await axios.post(
        "https://zjrtewtlami4oic3hzimxzgrby0nhsaf.lambda-url.ap-south-1.on.aws/",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      console.log(response.data);
      setTranScript(response.data);
      setAnswerload(false);
    } catch (error) {
      console.error("Error uploading the file", error);
    }
  };

  const [genaiaccess, setgenaiaccess] = useState(false);

  useEffect(() => {
    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    const userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    const jsondata = JSON.parse(userdata);
    const emailObj = jsondata.UserAttributes.find(
      (item) => item.Name === "email",
    );
    const email = emailObj?.Value || "";

    setgenaiaccess(email.includes("genai2244"));
  }, []);

  const handleUpload = async () => {
    // Handle uploading logic here, e.g., send csvFile to server
    await deleteObjectsFromFolder();
    console.log("Inside handleUpload");
    var username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    // setPdfDone(true);
    setZipDone(true);
    // console.log("Uploading CSV file:", pdfdone);
    // if (!pdfdone) return;

    const s3 = new AWS.S3({
      accessKeyId: "AKIA3AQTRT6P7J7N3JUJ",
      secretAccessKey: "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",
      region: "ap-south-1",
    });

    const params = {
      Bucket: "python-libs-customchat",
      Key: username + "/" + file.name,
      Body: file,
    };

    try {
      await s3.upload(params).promise();
      console.log("File uploaded successfully");
      // Optionally, you can reset the state here
      // setcsvload(false);
      // setPdfDone(true)
      setZipDone(true);
      setError("Resume uploaded successfully.");
      // setFile(null);
    } catch (error) {
      console.error("Error uploading file:", error);
      setError(
        "Error while uploading file, please refresh the page and try again.",
      );
      // setcsvload(false);
      // setPdfDone(false)
      setZipDone(false);
    }
  };

  const handleUpload1 = async () => {
    // await deleteObjectsFromFolder();
    // Handle uploading logic here, e.g., send csvFile to server
    var username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    setPdfDone(true);
    // console.log("Uploading CSV file:", pdfdone);
    // if (!pdfdone) return;

    const s3 = new AWS.S3({
      accessKeyId: "AKIA3AQTRT6P7J7N3JUJ",
      secretAccessKey: "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",
      region: "ap-south-1",
    });

    const params = {
      Bucket: "python-libs-customchat",
      Key: username + "/" + file1.name,
      Body: file1,
    };

    try {
      await s3.upload(params).promise();
      console.log("File uploaded successfully");
      // Optionally, you can reset the state here
      // setcsvload(false);
      setPdfDone(true);
      setError("Job description uploaded successfully.");
      // setFile1(null);
    } catch (error) {
      console.error("Error uploading file:", error);
      setError(
        "Error while uploading file, please refresh the page and try again.",
      );
      setPdfDone(false);
    }
  };

  const handleTrain = async () => {
    //add filename passing parameter in post request and run post request of chatbot
    if (file && pdfdone && file1 && zipdone) {
      setError("");
      setTrainload(true);
      setdeleteError("");
      console.log("training started");
      var username = localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      );
      var traindata = JSON.stringify({
        docpath: username,
        docname1: file.name,
        docname2: file1.name,
      });
      // var promptdata = JSON.stringify({
      //   docpath: username,
      //   docname: file1.name,
      // });
      const trainoption = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: traindata,
      };

      // const promptoption = {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   body: promptdata,
      // };

      // Create the fetch requests
      const requesttrain = fetch(
        // "https://ixies944jb.execute-api.ap-south-1.amazonaws.com/dev/jd-pdf-training",
        "https://6twdcbjz17.execute-api.ap-south-1.amazonaws.com/dev/vendor_training",
        trainoption,
      );
      // const requestprompt = fetch(
      //   "https://ixies944jb.execute-api.ap-south-1.amazonaws.com/dev/prompt-engineered-training",
      //   promptoption
      // );

      Promise.all([requesttrain])
        .then(async ([trainresponse]) => {
          if (!trainresponse.ok) {
            setError("Training Failed!");
            setTrainload(false);
            throw new Error("One or both requests failed");
          }
          const data1 = await trainresponse.json();
          // const data2 = await promptresponse.json();

          // Handle the data from both responses
          console.log("Response from endpoint 1:", data1);
          // console.log("Response from endpoint 2:", data2);
          if (trainresponse.ok) {
            setError("Training completed.");
            setTrainload(false);
          }
        })
        .catch((error) => {
          // Handle any errors that occurred during the requests
          console.error("Error:", error);
          setError("Training Failed!");
          setTrainload(false);
        });
    } else {
      Swal.fire({
        html: "<p>Please upload the Zip file containing PDFs.</p>",
      });
    }
  };

  const handleCompare = async () => {
    //add filename passing parameter in post request and run post request of chatbot
    setDisplayText("");
    try {
      setCompareLoad(true); // Start the loading state
      // Add filename passing parameter in POST request and run POST request of chatbot
      var username = localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      );
      var traindata = JSON.stringify({
        docpath: username,
        userPrompt: userquery, // add user prompt to traindata
      });
      const trainoption = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: traindata,
      };

      // Create the fetch request
      const requesttrain = await fetch(
        // "https://ixies944jb.execute-api.ap-south-1.amazonaws.com/dev/jd-resume-response", // Replace with your actual AWS API endpoint
        "https://6twdcbjz17.execute-api.ap-south-1.amazonaws.com/dev/vendor_response", // Replace with your actual AWS API endpoint
        trainoption,
      );

      // Check if the response is successful
      if (!requesttrain.ok) {
        console.error(`HTTP error! status: ${requesttrain.status}`);
        return;
      }

      let response;
      try {
        response = await requesttrain.json();
      } catch (jsonError) {
        console.error("Error parsing JSON:", jsonError);
        return;
      }

      // Inspect the full response
      console.log("Full response:", response);

      // Handle the response based on the actual structure
      if (response?.messsage) {
        // Note the typo in "messsage"
        setTranScript(response.messsage);
        console.log("Response data:", response.messsage);
      } else {
        console.error("Unexpected response structure:", response);
      }

      // Log the data
      console.log("Response data:", response.body);
    } catch (error) {
      // Handle any errors
      console.error("There was an error with the fetch request:", error);
    } finally {
      setCompareLoad(false); // End the loading state
    }
  };

  const handleButtonClick = () => {
    if (file && file1) {
      handleTrain();
    } else {
      setError("Please upload both file");
    }
  };

  const handleGenerateAnswer = () => {
    if (!userquery) {
      setError1("Please enter your query");
      return; // Exit the function if userquery is empty
    }

    if (!file || !file1) {
      setError1("Please upload both files");
      return; // Exit the function if both files are not uploaded
    }
    setError1("");
    handleCompare();
  };

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  return (
    <div>
      <div>
        <img
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to={link}>
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              {title}
            </h2>
          </div>
          <div className="col-auto align-self-end">
            {/* <Link to="/" style={{paddingRight:"2vw"}}>
                                <Button  variant="contained" color="primary" >Home</Button>
                            </Link> */}
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>
      {genaiaccess ? (
        <div
          style={{
            flex: "0.3",
            marginBottom: "1rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
            width: "80vw",
            gap: "3rem",
            margin: "auto",
          }}
          className="input-form-chatbot"
        >
          <div className="section-container">
            <h4>
              <strong>Resume upload window</strong>
            </h4>
            <hr style={{ background: "white" }}></hr>
            <div>
              <p>Upload a resume zip file:</p>
              <div className="field">
                <div>
                  <input
                    accept=".zip"
                    id="zip-upload"
                    type="file"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                  <label htmlFor="zip-upload">
                    <Button
                      variant="contained"
                      component="span"
                      style={{ width: "130px", marginRight: "1rem" }}
                    >
                      Select Zip
                    </Button>
                  </label>

                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    disabled={!file}
                    onClick={handleUpload}
                  >
                    Upload Zip
                  </Button>
                </div>
                <Typography variant="body1">
                  <p style={{ wordBreak: "break-all", width: "350px" }}>
                    {file && `Selected file: ${file.name}`}
                  </p>
                </Typography>
              </div>

              <p>Upload a job description pdf file:</p>
              <div className="field">
                <div>
                  <input
                    accept=".pdf"
                    id="pdf-upload1"
                    type="file"
                    onChange={handleFileChange1}
                    style={{ display: "none" }}
                  />
                  <label htmlFor="pdf-upload1">
                    <Button
                      variant="contained"
                      component="span"
                      style={{ width: "130px", marginRight: "1rem" }}
                    >
                      Select PDF
                    </Button>
                  </label>

                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    disabled={!file1}
                    onClick={handleUpload1}
                  >
                    Upload PDF
                  </Button>
                </div>
                <Typography variant="body1">
                  <p style={{ wordBreak: "break-all", width: "350px" }}>
                    {file1 && `Selected file: ${file1.name}`}
                  </p>
                </Typography>
              </div>

              <div style={{ display: "flex" }}>
                <Button
                  variant="contained"
                  color="primary"
                  component="span"
                  style={{ color: "white" }}
                  onClick={handleButtonClick}
                  startIcon={
                    trainload && <CircularProgress color="white" size={20} />
                  }
                >
                  Train
                </Button>
              </div>
              {/* <Button
                variant="contained"
                color="primary"
                onClick={handleCompare}
                // startIcon={
                //   answerload && <CircularProgress color="white" size={20} />
                // }
              >
                Compare
              </Button> */}
              <p>{error}</p>
            </div>
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
      <div
        className="input-form-chatbot"
        style={{
          flex: "0.3",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
          width: "80vw",
          margin: "2rem auto",
        }}
      >
        <div className="section-container">
          <p>Enter a question based on the PDF files:</p>
          {/* <TextField
              id="outlined-basic"
              // label="Question"
              variant="outlined"
              InputLabelProps={{
                style: { color: 'white' },
              }}
              InputProps={{
                style: { color: 'white' }, // Input text color
              }}
              style={{
                border: "1px solid white",
                borderRadius: "0.5rem",
                width: "100%",
              }}
              value={userquery} 
              onChange={(e) => setUserQuery(e.target.value)}
            /> */}
          <TextareaAutosize
            id="outlined-basic"
            minRows={1}
            value={userquery}
            onChange={(e) => setUserQuery(e.target.value)}
            style={{
              border: "1px solid white",
              borderRadius: "0.5rem",
              width: "100%",
              color: "white",
              backgroundColor: "transparent",
              padding: "16.5px 14px", // Adjusted padding to match TextField height
              fontSize: "16px", // Same font size as TextField
              lineHeight: "1.4375em", // Match the line height of MUI TextField
              resize: "none", // Disable manual resizing
              overflow: "hidden", // Hide scrollbar
              boxSizing: "border-box", // Ensure padding and border are included in the element's width and height
            }}
          />
          <Button
            style={{ margin: "1rem 0" }}
            variant="contained"
            color="primary"
            onClick={handleGenerateAnswer}
            startIcon={
              compareLoad && <CircularProgress color="white" size={20} />
            }
          >
            Generate Answer
          </Button>
          <p>{error1}</p>
        </div>
        <br />
        <br />
        <div className="section-container">
          <h4>
            <strong>Generated Response</strong>
          </h4>
          <hr style={{ background: "white" }}></hr>
          {displayText.length > 0 ? (
            <pre
              style={{
                color: "white",
                fontFamily: "sans-serif",
                wordWrap: "break-word",
                whiteSpace: "pre-wrap",
              }}
            >
              {displayText}
            </pre>
          ) : (
            "Response will be displayed here"
          )}
        </div>
      </div>
    </div>
  );
}
